import { firstSearchExecutedSelector } from '../../../features/search/search-selectors.js';
import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * Creates a `SearchStatus` controller instance.
 *
 * @param engine - The headless engine.
 * @returns A `SearchStatus` controller instance.
 * */
export function buildCoreStatus(engine) {
    if (!loadSearchStateReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const getState = () => engine.state;
    return {
        ...controller,
        get state() {
            const state = getState();
            return {
                hasError: state.search.error !== null,
                isLoading: state.search.isLoading,
                hasResults: !!state.search.results.length,
                firstSearchExecuted: firstSearchExecutedSelector(state),
            };
        },
    };
}
function loadSearchStateReducers(engine) {
    engine.addReducers({ search });
    return true;
}
